<mat-sidenav-container class="contact-list__root container" [hasBackdrop]="true">
  <mat-sidenav class="fixed" #drawer [mode]="'over'" position="start">
    <app-organizations
      [profile]="profile() || undefined"
      (logout)="onLogout()"
      (close)="drawer.toggle()"
      (selected)="onOrganizationSelected($event)"
    ></app-organizations>
  </mat-sidenav>
  <section class="contact-list__root_logo-ctn header">
    <mat-toolbar>
      <mat-toolbar-row>
        <div class="header__content">
          <div class="left">
            <button mat-icon-button (click)="drawer.toggle()" aria-label="Menu">
              <mat-icon>menu</mat-icon>
            </button>
            <h3>{{ currentOrganization()?.description }}</h3>
          </div>
        </div>
      </mat-toolbar-row>
    </mat-toolbar>
  </section>
  <section class="contact-list">
    <form [formGroup]="form" class="configuration-form">
      <app-dashboard-section-header [headerText]="'Alert Subject'" [hideAddButton]="true">
        <p class="configuration-hint">Who or what this alert is about.</p>
        <div class="field-grid">
          <div class="setting-card">
            <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
              <mat-label>Singular</mat-label>
              <input
                matInput
                type="text"
                required
                formControlName="subjectLabel"
                [maxlength]="subjectMax"
                [placeholder]="placeholders.subjectLabel"
              />
              <mat-hint align="end">{{ subjectLength() }} / {{ subjectMax }}</mat-hint>
              @if (form.controls.subjectLabel.hasError('required')) {
                <mat-error>Required</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="setting-card">
            <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
              <mat-label>Plural</mat-label>
              <input
                matInput
                type="text"
                required
                formControlName="subjectLabelPlural"
                [maxlength]="subjectMax"
                [placeholder]="placeholders.subjectLabelPlural"
              />
              <mat-hint align="end">{{ pluralLength() }} / {{ subjectMax }}</mat-hint>
              @if (form.controls.subjectLabelPlural.hasError('required')) {
                <mat-error>Required</mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </app-dashboard-section-header>

      <app-dashboard-section-header [headerText]="'Default Alert Settings'" [hideAddButton]="true">
        <div class="field-grid">
          <div class="setting-card setting-card--span-all">
            <div class="notify-window-row">
              <mat-form-field appearance="outline" class="notify-window-row__field" subscriptSizing="dynamic">
                <mat-label>Alert window start</mat-label>
                <input matInput type="time" required formControlName="notifyWindowStart" />
                <mat-hint>Earliest time to send alerts</mat-hint>
              </mat-form-field>
              <mat-form-field appearance="outline" class="notify-window-row__field" subscriptSizing="dynamic">
                <mat-label>Alert window end</mat-label>
                <input matInput type="time" required formControlName="notifyWindowEnd" />
                <mat-hint>Latest time to start new sends</mat-hint>
              </mat-form-field>
              <mat-form-field appearance="outline" class="notify-window-row__field" subscriptSizing="dynamic">
                <mat-label>Time zone</mat-label>
                <mat-select formControlName="notifyWindowTimeZone">
                  @for (tz of timeZoneOptions; track tz.id) {
                    <mat-option [value]="tz.id">{{ tz.label }}</mat-option>
                  }
                </mat-select>
                <mat-hint>Used for schedule and window</mat-hint>
              </mat-form-field>
            </div>
          </div>
          <div class="setting-card setting-card--span-all">
            <div
              class="retry-settings-row"
              [class.retry-settings-row--with-target]="showDayTargetTime()"
            >
              <mat-form-field
                appearance="outline"
                class="retry-settings-row__attempts"
                subscriptSizing="dynamic"
              >
                <mat-label>Retry attempts</mat-label>
                <input
                  matInput
                  type="number"
                  required
                  min="1"
                  [max]="retryAttemptsMax"
                  formControlName="retryAttempts"
                  [placeholder]="'' + placeholders.retryAttempts"
                />
                @if (form.controls.retryAttempts.hasError('required')) {
                  <mat-error>Required</mat-error>
                }
                @if (form.controls.retryAttempts.hasError('max')) {
                  <mat-error>Maximum is {{ retryAttemptsMax }}</mat-error>
                }
              </mat-form-field>
              <mat-form-field
                appearance="outline"
                class="retry-settings-row__interval"
                subscriptSizing="dynamic"
              >
                <mat-label>Interval between retries</mat-label>
                <input
                  matInput
                  type="number"
                  required
                  [min]="intervalInputMin()"
                  step="1"
                  formControlName="retryInterval"
                  [placeholder]="intervalPlaceholder()"
                />
                @if (form.controls.retryInterval.hasError('minInterval')) {
                  <mat-error>Minimum is {{ minRetryIntervalMinutes }} minutes</mat-error>
                } @else if (
                  form.controls.retryInterval.hasError('required') ||
                  form.controls.retryInterval.hasError('min') ||
                  form.controls.retryInterval.hasError('pattern')
                ) {
                  <mat-error>Enter a whole number of 1 or more</mat-error>
                }
              </mat-form-field>
              <mat-form-field
                appearance="outline"
                class="retry-settings-row__unit"
                subscriptSizing="dynamic"
              >
                <mat-label>Unit</mat-label>
                <mat-select formControlName="retryIntervalUnit">
                  @for (unit of intervalUnits; track unit) {
                    <mat-option [value]="unit">{{ intervalUnitLabel(unit) }}</mat-option>
                  }
                </mat-select>
                <mat-hint>&nbsp;</mat-hint>
              </mat-form-field>
              @if (showDayTargetTime()) {
                <mat-form-field
                  appearance="outline"
                  class="retry-settings-row__target-time"
                  subscriptSizing="dynamic"
                >
                  <mat-label>Target time of day</mat-label>
                  <input matInput type="time" required formControlName="targetTime" />
                  @if (form.controls.targetTime.hasError('required')) {
                    <mat-error>Required when interval is in days</mat-error>
                  }
                </mat-form-field>
              }
            </div>
          </div>
          <div class="setting-card">
            <div class="sms-toolbar">
              <a class="use-default" href="#" (click)="$event.preventDefault(); onUseDefault()">
                Use default
              </a>
            </div>
            <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
              <mat-label>Text message</mat-label>
              <textarea
                matInput
                rows="6"
                required
                formControlName="smsBody"
                [maxlength]="smsMax"
                [placeholder]="placeholders.smsBody"
              ></textarea>
              <mat-hint align="end">{{ smsLength() }} / {{ smsMax }}</mat-hint>
              @if (form.controls.smsBody.hasError('required')) {
                <mat-error>Required</mat-error>
              } @else if (form.controls.smsBody.hasError('smsTokens')) {
                <mat-error>{{ smsTokenError() }}</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="setting-card setting-card--press0">
            <p class="token-help">
              {{ smsPlaceholderHelp }}
              @for (label of smsTokenLabels; track label) {
                <code>{{ label }}</code>
              }
            </p>
            <div class="press0-row">
              <mat-checkbox formControlName="pressZeroToConnect">
                Include “press 0 to connect now” in the alert
              </mat-checkbox>
              <mat-form-field appearance="outline" class="press0-row__channel" subscriptSizing="dynamic">
                <mat-label>Delivery</mat-label>
                <mat-select formControlName="notifyChannel">
                  @for (channel of notifyChannels; track channel) {
                    <mat-option [value]="channel">{{ notifyChannelLabel(channel) }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="setting-card">
            <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
              <mat-label>Link title</mat-label>
              <input matInput type="text" formControlName="urlTitle" placeholder="e.g. Patient portal" />
            </mat-form-field>
          </div>
          <div class="setting-card">
            <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
              <mat-label>Link URL</mat-label>
              <input matInput type="url" formControlName="urlHyperlink" placeholder="https://" />
            </mat-form-field>
          </div>
        </div>
        <p class="configuration-hint">Appended to the outbound text (urlTitle + urlHyperlink).</p>
      </app-dashboard-section-header>
      <div class="save-row">
        <button
          mat-flat-button
          color="primary"
          type="button"
          (click)="onSave()"
          [disabled]="form.invalid || saving() || loadingConfig()"
        >
          SAVE
        </button>
      </div>
    </form>
  </section>
</mat-sidenav-container>
